import { css } from 'linaria';
import { cssTheme } from '@uds/theme-utils';

const pendingButton = css`
  pointer-events: none;

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
  & [role='img'] {
    animation: spin 1s linear infinite;
  }
  & svg {
    transform: scaleX(-1);
  }
`;

const customButton = css`
  background-color: ${cssTheme.palette.grey12};
  color: ${cssTheme.palette.grey02};
`;

export const classNames = {
  pendingButton,
  customButton,
};
